import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    Injectable,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { InputModule } from 'src/app/input/input.module';
import { NzModalService } from 'ng-zorro-antd/modal';
import { BankChargesComponent } from '../bank-charges/bank-charges.component';
import { BankCashAccountSelectComponent } from '../select/account/cac-select/cac-select.component';

@Injectable()
class MultiPaymentFormService {
    private fb = inject(FormBuilder);
    
    createMultiPaymentForm() {
        const form = this.fb.group({
            accountId: ['', []],
            account: [<any>null, [Validators.required]],
            description: ['', [Validators.maxLength(50)]],
            referenceNo: ['', [Validators.maxLength(50)]],
            amount: [0, [Validators.min(0.01)]],
            bankChargesAmount: [0, []],
            bankChargesAccountId: [<any>null, []],
            bankChargesAccount: [<any>null, []],
          });
      
          form.controls.account.valueChanges.subscribe(val => {
            form.controls.accountId.setValue(val?.id);
          });
      
          return form;
    }
}
  
@Component({
    selector: 'app-multi-payment-edit-form',
    templateUrl: './multi-payment-edit-form.component.html',
    standalone: true,
    imports: [
        InputModule,
        BankCashAccountSelectComponent
    ],
    providers: [MultiPaymentFormService],
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiPaymentEditFormComponent {      
    constructor(
        private modalSrv: NzModalService,
        private formSrv: MultiPaymentFormService
    ) {}

    form = this.formSrv.createMultiPaymentForm();

    @Input() get value() {
        return this.form.value;
    }
    set value(value: any) {
        this.form.reset(value);
    }

    setDescription(val: string) {
        this.form.controls.description.setValue(val);
    }

    bankChargesModal() {
        const modal = this.modalSrv.create({
          nzTitle: 'Bank Charges',
          nzContent: BankChargesComponent,
          nzWidth: '600px',
          nzOnOk: component => {
            const instance = modal.getContentComponent();
            this.form.controls.bankChargesAccountId.setValue(
              instance.bankChargesAccountId
            );
          }
        });
        const instance = modal.getContentComponent();
        instance.bankChargesAccountId =
          this.form.controls.bankChargesAccountId.value;
    }
}
  